const $ = window.jQuery;

const SingleProduct = {
	product_id: femp.post_id,

	init() {
		const $productBody = $('body.single-product');
		if (!$productBody.length) return;

		const moduleThis = this;

		const $cart = $productBody.find('form.cart');
		const $qtyInput = $productBody.find('.qty');
		const $productToggles = $('#product-toggles');
		const $toggles = $productToggles.find('button');
		const $descContainer = $('#product-desc');
		const $filesContainer = $('#product-files');

		$productToggles.find('button').on('click', function () {
			$toggles.removeClass('active');

			$(this).toggleClass('active');

			$descContainer.hide();
			$filesContainer.hide();
			const toggleTarget = $(this).attr('data-togglefor');
			$(toggleTarget).show();
		});

		$cart.on('click', 'button.yg-dec, button.yg-inc', function () {
			$cart.addClass('loading');
			// Get current quantity values
			var qty = $(this).closest('form.cart').find('.qty');
			var val = parseFloat(qty.val());
			var max = parseFloat(qty.attr('max'));
			var min = parseFloat(qty.attr('min'));
			var step = parseFloat(qty.attr('step'));
			var cat_item_key = $(this).attr('data-cart-item-key');
			// Change the value if plus or minus
			if ($(this).is('.yg-inc')) {
				if (max && max <= val) {
					qty.val(max).trigger('change');
				} else {
					qty.val(val + step).trigger('change');
				}
				var data = {
					product_id: moduleThis.product_id,
					quantity: 1,
				};
			} else {
				if (min && min >= val) {
					qty.val(min).trigger('change');
				} else if (val > 0) {
					qty.val(val - step).trigger('change');
				}
			}

			if ($qtyInput[0]) {
				moduleThis.resizeInput.call($qtyInput[0]); // immediately call the function
			}
		});

		if ($qtyInput[0]) {
			$qtyInput[0].addEventListener('input', moduleThis.resizeInput); // bind the "resizeInput" callback on "input" event
			moduleThis.resizeInput.call($qtyInput[0]); // immediately call the function
		}
	},
	resizeInput() {
		this.style.width = this.value.length + 'ch';
	},
};

export default SingleProduct;
